// extracted by mini-css-extract-plugin
module.exports = {"cookieNotificationHolder":"MobileCookieNotification_cookieNotificationHolder__3ZuUG","linkWrapper":"MobileCookieNotification_linkWrapper__3rAzb"};